(() => {
  if (customElements.get('sf-size-guide')) return;
  customElements.define('sf-size-guide', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this.events) return;
      this.dialog = this.querySelector('[data-sg-dialog]');
      this.trigger = this.querySelector('[data-sg-open]');
      const fallback = this.querySelector('[data-sg-fallback]');
      const content = this.querySelector('[data-sg-content]');
      const close = this.querySelector('[data-sg-close]');
      const units = this.querySelector('[data-sg-units]');
      const tabs = [...this.querySelectorAll('[data-sg-unit]')];
      const panels = [...this.querySelectorAll('[data-sg-panel]')];
      if (!this.dialog || typeof this.dialog.showModal !== 'function' || !this.trigger || !fallback || !content || !close || !units || tabs.length !== 2 || panels.length !== 2) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      const select = (unit, focus = false) => {
        this.unit = unit;
        tabs.forEach((tab, index) => {
          const selected = tab.dataset.sgUnit === unit;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          panels[index].hidden = !selected;
          if (selected && focus) tab.focus();
        });
      };
      tabs.forEach((tab, index) => {
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', () => select(tab.dataset.sgUnit), {signal});
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs[1] : tabs[1 - index];
          select(next.dataset.sgUnit, true);
        }, {signal});
      });
      this.dialog.append(content);
      fallback.hidden = true;
      close.hidden = false;
      units.hidden = false;
      this.trigger.hidden = false;
      this.classList.add('is-enhanced');
      select(this.unit || (this.dataset.defaultUnit === 'cm' ? 'cm' : 'in'));
      this.trigger.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.returnFocus = this.trigger;
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('sf-size-guide-open');
      }, {signal});
      close.addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, {signal});
      this.dialog.addEventListener('close', () => {
        this.releasePage();
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll: true});
      }, {signal});
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]')]
          .filter(node => node.tabIndex >= 0 && !node.disabled && !node.closest('[hidden]') && node.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!first) return;
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, {signal});
      // Keep native Escape/cancel behavior; wrap Tab explicitly at the content boundaries.
    }
    releasePage() {
      if (!document.querySelector('sf-size-guide dialog[open]')) document.documentElement.classList.remove('sf-size-guide-open');
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.events?.abort();
      this.events = null;
      this.releasePage();
    }
  });
})();
